import React, { useEffect, useState } from 'react';
import { useHistory, NavLink } from "react-router-dom";
import { State, City } from 'country-state-city';
import axios from 'axios';
import { BASEURL } from "../Config";
import swal from 'sweetalert';
import MyDropzone from "../components/MyDropzone";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

const AddDistributor = (props) => {
    const history = useHistory(); 
    const { uuid } = props;
    const heading = uuid ? 'Edit Distributor' : 'Add Distributor';
    const [distributorName, setDistributorName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [stateName, setStateName] = useState("");
    const [city, setCity] = useState("");
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [distributorPhoto, setDistributorPhoto] = useState("");
    const [aadhaar, setAadhaar] = useState("");
    const [pan, setPan] = useState("");
    const [gstDoc, setGstDoc] = useState("");

    // Errors
    const [distributorNameError, setDistributorNameError] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [stateError, setStateError] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [distributorPhotoError, setDistributorPhotoError] = useState(false);
    const [aadhaarError, setAadhaarError] = useState(false);
    const [panError, setPanError] = useState(false);
    const [gstDocError, setGstDocError] = useState(false);


    useEffect(() => {
        const states = State.getStatesOfCountry('IN').map(state => { return { name: state.name, isoCode: state.isoCode }});
        setStates(states);
        if(uuid) { fetchDistributor() }
    }, []);

    const fetchDistributor = () => {
        axios.get(`${BASEURL}/api/v1/distributor/query?uuid=${uuid}`)
        .then(res => {
          const data = res.data[0];
          setDistributorName(data.name);
          setPhoneNumber(data.phoneNo);
          setAddress(data.address);
          const statesArr = State.getStatesOfCountry('IN').map(state => { return { name: state.name, isoCode: state.isoCode }});
          if(data?.state) {
            const selectedStateName = statesArr.find(state => state.name === data.state);
            setState(selectedStateName?.isoCode);
            setStateName(selectedStateName?.name || '');
            const cities = City.getCitiesOfState('IN', selectedStateName?.isoCode).map(city => city.name);
            setCities(cities);
            if(data?.city) {
                setCity(data?.city);
            }
          }
          setDistributorPhoto(data.distributorPhoto);
          setAadhaar(data.aadhaar);
          setPan(data.pan);
          setGstDoc(data.GSTOrSalesTaxRegDoc);
        })
        .catch(err => {
          console.log("Fetch distributor error", err);
          swal('Error', 'Failed to fetch Distributor details', 'error');
        });
      }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "distributorName") {
            setDistributorName(value);
            setDistributorNameError(false);
        } else if (name === "phoneNumber") {
            setPhoneNumber(value);
            setPhoneNumberError(false);
        } else if (name === "address") {
            setAddress(value);
            setAddressError(false);
        } else if (name === "state") {
            setState(value);
            setStateName(states.find(state => state.isoCode === value)?.name || '');
            const cities = City.getCitiesOfState('IN', value).map(city => city.name);
            setCities(cities);
            setStateError(false);
        } else if (name === "city") {
            setCity(value);
            setCityError(false);
        }
    };

    // validateData
    const validateData = () => {
        let error = false;

        if (!distributorName) {
            setDistributorNameError(true);
            error = true;
        }
        if (!phoneNumber) {
            setPhoneNumberError(true);
            error = true;
        }
        if (!address) {
            setAddressError(true);
            error = true;
        }
        if (!state) {
            setStateError(true);
            error = true;
        }
        if (!city) {
            setCityError(true);
            error = true;
        }
        if (!distributorPhoto) {
            setDistributorPhotoError(true);
            error = true;
        }
        if (!aadhaar) {
            setAadhaarError(true); 
            error = true;
        } 
        if (!pan) {
            setPanError(true);
            error = true;
        }
        if (!gstDoc) {
            setGstDocError(true);
            error = true;
        }
        return error;
    }

    const handleSubmit = () => {
        let validationError = validateData();
        if (validationError) {
          swal('Error in Creating Sales Manager', 'Fill the required fields', 'error');
        } else {
          const inputObj = {
            name: distributorName,
            phoneNo: phoneNumber,
            aadhaar: aadhaar,
            pan: pan,
            distributorPhoto: distributorPhoto,
            GSTOrSalesTaxRegDoc: gstDoc,
            address: address,
            state: stateName,
            city: city,
            createdBy: 'admin'
          };
          if(uuid) {
            axios.put(`${BASEURL}/api/v1/distributor/${uuid}`, inputObj)
            .then(res => {
              if (res.status === 200) {
                swal("Success", "Distributor Updated successfully", "success")
                .then(function () {
                  window.location = "distributors";
                })
              }
            })
            .catch((err) => {
              swal('Error in Updating Distributor', err.response.data, 'error');
              console.log('Update Distributor Error', err);
            })
          } else {
            axios.post(`${BASEURL}/api/v1/distributor`, inputObj)
                .then(res => {
                if (res.status === 200) {
                    swal("Success", "Distributor Created successfully", "success")
                        .then(function () {
                            window.location = "distributors";
                        })
                }
                })
                .catch((err) => {
                console.log(err.response.data)
                swal('Error in Creating Distributor', err.response.data, 'error');
                console.log('Create Distributor Error', err);
                })
            }
        }
    }

    return (
        <div id="wrapper">
            <Sidebar act="distributors" />
            {/* Content Wrapper */}
            <div className="content-page">
                {/* Main Content */}
                <div className="content">
                    <Topbar act={heading} breadcrumbItems={["Sales App", { label: "Distributors", path: "distributors" }, heading]} />
                    {/* container */}
                    {/* content */}
                    <div className="container-fluid main-container">
                        <div className="card main-card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="distributorName" className="form-label">Distributor Name *</label>
                                            <input type="text" id="distributorName" className="form-control" onChange={handleChange}
                                                name="distributorName" placeholder="Enter Distributor Name" value={distributorName} />
                                                {distributorNameError ? <p className="errTxt">Distributor Name is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="phoneNumber" className="form-label">Phone Number *</label>
                                            <input type="text" id="phoneNumber" className="form-control" onChange={handleChange}
                                                name="phoneNumber" placeholder="Enter Phone Number" value={phoneNumber} />
                                                {phoneNumberError ? <p className="errTxt">Phone Number is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State *</label>
                                        <select id="state" className="form-control" name='state' onChange={handleChange} value={state}>
                                            <option value="">Select State</option>
                                            {states.map((state, idx) =>
                                            <option value={state.isoCode} key={idx}>{state.name}</option>
                                            )}
                                        </select>
                                        {stateError ? <p className="errTxt">State is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City *</label>
                                        <select id="city" className="form-control" name='city' onChange={handleChange} value={city}>
                                            <option value="">Select City</option>
                                            {cities.map((cityName, idx) =>
                                            <option value={cityName} key={idx}>{cityName}</option>
                                            )}
                                        </select>
                                        {cityError ? <p className="errTxt">City is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="address" className="form-label">Address *</label>
                                            <textarea id="address" className="form-control" onChange={handleChange}
                                                name="address" placeholder="Enter Address" value={address} />
                                            {addressError ? <p className="errTxt">Address is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label>Upload Distributor Photo *</label>
                                            <MyDropzone file={distributorPhoto} setFile={setDistributorPhoto} setError={setDistributorPhotoError} fromPage="addDistributor" />
                                            {distributorPhotoError ? <p className="errTxt">Distributor Photo is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label>Upload Aadhaar *</label>
                                            <MyDropzone file={aadhaar} setFile={setAadhaar} setError={setAadhaarError} fromPage="addDistributor" />
                                            {aadhaarError ? <p className="errTxt">Aadhaar is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label>Upload PAN *</label>
                                            <MyDropzone file={pan} setFile={setPan} setError={setPanError} fromPage="addDistributor" />
                                            {panError ? <p className="errTxt">PAN is Required</p> : ''}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label>Upload GST/Sales Tax Registration Doc *</label>
                                            <MyDropzone file={gstDoc} setFile={setGstDoc} setError={setGstDocError} fromPage="addDistributor" />
                                            {gstDocError ? <p className="errTxt">GST/Sales Tax Registration Doc is Required</p> : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 d-flex">
                                    <button type="submit" className="btn btn-customprimary" onClick={handleSubmit}>{uuid ? 'Update' : 'Create'}</button>
                                    <button type="button" style={{ color: '#6c757d' }} className="btn" onClick={() => {history.push('/distributors')}}>Cancel</button>
                                </div>
                            </div>
                            {/* end row */}
                        </div> {/* end card-body */}
                    </div> {/* end card*/}
                </div>
                {/* End of Main Content */}
                <Footer />
            </div>
            {/* End of Content Wrapper */}
        </div>
    );
}

export default AddDistributor;
